export default __webpack_public_path__ + "static/media/CSS3.b0696b45.svg";